import { ExtendedRoute } from '@ideapa/app-common';
import { createAction, props } from '@ngrx/store';

export const init = createAction(
  '[Ngrx/Navigation] Init',
  props<{ items: ExtendedRoute[] }>()
);

export const navigate = createAction(
  '[Ngrx/Navigation] Navigate',
  props<{ path: string }>()
);

export const manualClose = createAction(
  '[Ngrx/Navigation] Manual close Tab',
  props<{ path: string; navigate?: boolean }>()
);

export const closeTab = createAction(
  '[Ngrx/Navigation] Close Tab',
  props<{ path: string; navigate?: boolean }>()
);

export const showTab = createAction(
  '[Ngrx/Navigation] Show Tab',
  props<{ path: string }>()
);

export const closeEnteAnnoRelatedTabs = createAction(
  '[Ngrx/Navigation] Close Ente Related Tabs'
);

export const closeModuloRelatedTabs = createAction(
  '[Ngrx/Navigation] Close Modulo Related Tabs'
);

export const navigateToFirstTab = createAction(
  '[Ngrx/Navigation] Navigate to first available Tab'
);
